module.exports = "https://web-assets.ifttt.com/packs/media/pro_sla/sla_pro_bg@3x-06d5f701.png";